<template>
  <div
    v-if="showOptInToggler"
    class="cf-flex cf-flex--column cf-flex--gap-16"
  >
    <cf-switch-input
      :show-info-icon="!showSmsDisclaimer"
      :description="smsTermsContent"
      :model-value="session.smsReceiptOptIn"
      label="Text Receipt"
      name="optIn"
      @update:model-value="optInChangeHandler"
    />

    <p
      v-if="showSmsDisclaimer"
      class="cf-subtitle cf-subtitle--2"
      v-html="smsTermsContent"
    />
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfSwitchInput from '@/view/components/shared/cf-switch-input/index.vue';


  export default {
    name: 'SmsReceiptOptIn',

    components: {
      CfSwitchInput
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('session', ['orderDetails', 'session']),

      showOptInToggler() {
        return !['pay', 'table'].includes(this.orderDetails.orderType) && this.merchant.options.showSmsReceiptOption;
      },

      showSmsDisclaimer() {
        return this.merchant.options.showSmsDisclaimer;
      },

      smsTermsContent() {
        return this.content.PaymentScreen.metadata.smsTerms;
      }
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        if (this.merchant.options.showSmsReceiptOption) this.optInChangeHandler(this.merchant.options.sendSmsOrderReceiptEnabled);
      },

      optInChangeHandler(optIn) {
        this.$store.dispatch('session/updateSmsReceiptOptIn', optIn);
      }
    }
  };
</script>
